module.exports = __webpack_public_path__ + "static/media/star_black.d1d08460.svg";